var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-timepicker',_vm._g({staticClass:"base-timepicker",class:{ right: _vm.right },attrs:{"value":_vm._value,"format":"HH:mm","hide-clear-button":"","hide-disabled-hours":"","hide-disabled-minutes":"","auto-scroll":"","lazy":_vm.lazy,"drop-direction":"auto","hour-range":_vm.hourRange,"minute-range":_vm.minuteRange}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }